import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, TypographyStyledGlobal, fontWeight, fontSize } from '../../../../../theme';
import ExportType from '../../../../../utils/enum/ExportType';
import ExportDropdown from '../../../../Dashboard/ExportDropdown/exportDropdown';
import { ConversationButtonStyled } from '../../../../Dashboard/styled';
import Loader from '../../../../Loader/loader';
import { ChatingProps } from '../../dashboardModalInterface';
import { ConversationDivStyled, ChatbotQuestionStyled, ChatbotResponseStyled, InputStyled } from './styled';
import TextTypingEffectWithTextsFadeOut from './typingEffect';
import { ReactComponent as ChatbotConversationImage } from '../../../../../assets/charts/chatbot-conversation.svg';

interface ChatbotConversationProps {
    conversation: Array<ChatingProps>;
    getChatbotResponse: (isSummary: boolean, chatEntry: string) => void;
    waitingForChatAnswer: boolean;
    handleIsRenderedChat: (chatIdRendered: number) => void;
    surveyId: string
    filterClauseLabel: string | undefined
    scopeClauseLabel: string | undefined
    summary?: string
    questionLabel: string
    surveyName?: string
    dashboardName?: string
}

const ChatbotConversation: FC<ChatbotConversationProps> = ({ conversation, getChatbotResponse, waitingForChatAnswer, handleIsRenderedChat, surveyId, filterClauseLabel, scopeClauseLabel, summary, questionLabel, surveyName, dashboardName }) => {
    const { t } = useTranslation('dashboard');
    const [chatEntry, setChatEntry] = useState<string>('');
    const handleNewChatEntry = (entry: string) => {
        if (entry) {
            getChatbotResponse(false, entry);
            setChatEntry('');
        }
    };
    const divRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
        divRef.current?.scrollTo({ top: 2000 });
    }, [conversation]);

    return (
        <>
            <ConversationDivStyled ref={divRef}>
                {conversation?.map((c: ChatingProps) => (
                    <React.Fragment key={c.id}>
                        <ChatbotQuestionStyled>{c.entry}</ChatbotQuestionStyled>
                        { c.answer === '...' ? <Loader justifyContent='left' size={20} /> : <ChatbotResponseStyled><TextTypingEffectWithTextsFadeOut chatId={c.id} handleIsRenderedChat={handleIsRenderedChat} hasToUseTypingEffect={!c.alreadyRendered} text={c.answer} /></ChatbotResponseStyled>}
                    </React.Fragment>
                ))}
            </ConversationDivStyled>
            <InputStyled
                disabled={waitingForChatAnswer}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setChatEntry(event.target.value)}
                onKeyDown={((event: any) => event.key === 'Enter' && handleNewChatEntry(event.target.value))}
                placeholder={t('addIndicatorModal.addChatbotIndicator.placeholder')}
                value={chatEntry}
                autoFocus
                disableUnderline
            />
            <TypographyStyledGlobal
                color={colors.grey400}
                margin='10px 0px 10px 10px'
                size={fontSize.sm}
                style={{ alignSelf: 'flex-start' }}
                textAlign='left'
                weight={fontWeight.semiRegular}
            >
                {t('addIndicatorModal.addChatbotIndicator.aiGeneratedContent')}
            </TypographyStyledGlobal>
            <div style={{ display: 'flex', gap: '10px', float: 'right', flexDirection: 'row', marginTop: '10px', alignSelf: 'flex-end' }}>
                <ExportDropdown conversation={conversation} dashboardName={dashboardName} disabled={!summary && !(conversation && conversation.length > 0)} exportCase={ExportType.CHAT} exportPdf={false} filterClauseLabel={filterClauseLabel} horizontal='right' questionLabel={questionLabel} scopeClauseLabel={scopeClauseLabel} selectedClauseFilter={[]} selectedDateRange={null} selectedScope={[]} summary={summary} surveyId={surveyId} surveyName={surveyName} vertical='top' exportTxt exportWord />
                <ConversationButtonStyled bgColor={colors.default} bgColorHover={colors.defaultHover} fontColor='white' onClick={() => handleNewChatEntry(chatEntry)}>
                    <ChatbotConversationImage height={25} width={25} />
                    <TypographyStyledGlobal
                        margin='0px'
                        weight={fontWeight.regular}
                    >
                        {t('addIndicatorModal.addChatbotIndicator.response')}
                    </TypographyStyledGlobal>
                </ConversationButtonStyled>
            </div>
        </>
    );
};

export default ChatbotConversation;
